import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/shared/utils/cn";

export interface SectionHeaderProps extends Omit<ComponentProps<"div">, "title"> {
  title: ReactNode;
  count?: ReactNode;
  action?: ReactNode;
  headingId?: string;
}

export function SectionHeader({ title, count, action, headingId, className, ...props }: SectionHeaderProps) {
  return (
    <div className={cn("flex min-w-0 items-start justify-between gap-3", className)} {...props}>
      <div className="min-w-0">
        <h2 id={headingId} className="text-[21px] font-bold leading-tight text-foreground [overflow-wrap:anywhere]">{title}</h2>
        {count != null && <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{count}</p>}
      </div>
      {action && <div className="-mt-2 shrink-0">{action}</div>}
    </div>
  );
}
